import {
  Box,
  Button,
  Chip,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@/common/styles/style";
import SearchBox from "@/molecules/searchBox";
import { styles } from "./style";
import { GroupsType, TenantsType, UsersType } from "@/common/type/type";
import theme from "@/common/styles/theme";
import { MoreVert } from "@mui/icons-material";
import { getRoleName, roleInfo } from "@/helpers/getUserInfo";

interface UsersProps {
  handleSearch: (searchType: string, value: string) => void;
  setSelectedTenant: (value: React.SetStateAction<TenantsType | null>) => void;
  setSelectedGroup: (value: React.SetStateAction<GroupsType | null>) => void;
  setIsUnassigned: (value: React.SetStateAction<boolean>) => void;
  handleMenuClick: (event: React.MouseEvent<HTMLElement>, name: string) => void;
  usersToDisplay: (UsersType | undefined)[];
  filteredGroups: GroupsType[];
  search: {
    tenant: string;
    group: string;
    user: string;
  };
  userRole: number;
}

export default function Users({
  handleSearch,
  setSelectedTenant,
  setSelectedGroup,
  setIsUnassigned,
  handleMenuClick,
  usersToDisplay,
  filteredGroups,
  search,
  userRole,
}: UsersProps) {
  return (
    <Paper sx={styles.paper}>
      <Box sx={styles.paperSearchWrapper}>
        <SearchBox onSearch={(value) => handleSearch("user", value)} />
      </Box>
      <Box mt={2} sx={styles.buttonArea}>
        <Typography variant="h6">ユーザー一覧</Typography>
        {getRoleName(userRole) !== roleInfo.user ? (
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setSelectedTenant(null);
              setSelectedGroup(null);
              setIsUnassigned((prev) => !prev);
            }}
          >
            <Typography variant="body1">未所属</Typography>
          </Button>
        ) : null}
      </Box>
      <Box mt={1} sx={styles.paperListUser}>
        {(usersToDisplay as UsersType[])
          .filter(
            (user, index, self) =>
              self.findIndex(
                (u) =>
                  u.id === user.id &&
                  u.name === user.name &&
                  u.email === user.email &&
                  u.role === user.role
              ) === index
          )
          .filter((user) => {
            const isUserNameValid =
              typeof user.name === "string" &&
              typeof search.user === "string" &&
              user.name.toLowerCase().includes(search.user.toLowerCase());

            const isVisible = getRoleName(userRole) !== roleInfo.user;

            const belongsToGroup = filteredGroups.some((group) =>
              group.users?.some((groupUser) => groupUser.email === user.email)
            );

            return isUserNameValid && (isVisible || belongsToGroup);
          })
          .map((user, index) => {
            const userGroups = ((filteredGroups as GroupsType[]) || []).filter(
              (group) =>
                group.users?.some((groupUser) => groupUser.email === user.email)
            );

            return (
              <Box key={index} sx={styles.listItemUser} onClick={() => {}}>
                <Stack sx={styles.listItemUserStack}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={styles.userStack}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body1">{user.name}</Typography>
                      {userGroups.length > 0 ? (
                        userGroups.map((group) => (
                          <Chip
                            key={group.name}
                            label={group.name}
                            size="small"
                            sx={theme.typography.body2}
                          />
                        ))
                      ) : (
                        <Chip
                          key="no-group"
                          label="未所属"
                          size="small"
                          color="default"
                          sx={theme.typography.body2}
                        />
                      )}
                    </Stack>
                    {getRoleName(userRole) === roleInfo.admin ? (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMenuClick(e, user.name);
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    ) : null}
                  </Stack>
                  <Typography variant="body2" color="textSecondary">
                    {user.email}
                  </Typography>
                </Stack>
              </Box>
            );
          })}
      </Box>
    </Paper>
  );
}
